import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, Link } from 'react-router-dom';

import { AnalyticsEvent } from 'applications/GSP/shared/constants/analytics';
import { RoutePath } from 'applications/GSP/shared/constants/router';
import { useAnalytics } from 'applications/GSP/shared/hooks/analytics/useAnalytics';
import { Tile, Title, Content, Header, Action } from 'shared/components/Tile';
import { Button } from 'shared/components/buttons/Button';

import { Content as WidgetContent } from './components/Content';

import type { FC } from 'react';

export const UpcomingAssignments: FC = () => {
  const { t } = useTranslation();
  const analytics = useAnalytics();

  const onSeeAllUpcomingAssignments = useCallback(() => {
    analytics.track(AnalyticsEvent.DashboardViewAllUpcomingAssignments);
  }, [analytics]);

  return (
    <Tile>
      <Header>
        <Title>
          {t('GSP.pages.dashboard.widgets.upcomingAssignments.title')}
        </Title>
        <Action>
          <Button
            size="small"
            component={Link}
            onClick={onSeeAllUpcomingAssignments}
            to={generatePath(RoutePath.UpcomingAssignments)}
          >
            {t('GSP.pages.dashboard.widgets.upcomingAssignments.seeAll')}
          </Button>
        </Action>
      </Header>
      <Content>
        <WidgetContent />
      </Content>
    </Tile>
  );
};
